<template>
  <CheckoutCard>
    <h3 class="font-semibold text-xl">
      {{ $t("Booking details") }}
    </h3>
    <!-- INFO: Booking Details -->
    <div class="w-full grid grid-cols-2 gap-5">
      <Input name="contactDetails.first_name" :label="$t('First name')" type="text" class="col-span-2" />
      <Input name="contactDetails.last_name" class="col-span-2" :label="$t('Last name')" />
      <Select
        role="combobox"
        name="contactDetails.iso_country"
        class="col-span-2"
        :label="$t('Country')"
        :options="countryOptions" />
    </div>
    <hr class="my-3" />
    <!-- INFO: Main Contact Information -->
    <h3 class="font-semibold text-xl">
      {{ $t("Main contact information") }}
    </h3>
    <div class="w-full space-y-5">
      <template v-if="brandconfig.BRAND == 'demoshop'">
        {{
          $t(
            "You're currently in our demo portal. Please check your email and create a password for your account in order to create your first booking."
          )
        }}
      </template>
      <div v-else>
        <Input
          name="email"
          inputmode="email"
          aria-label="Email Address"
          :label="$t('Email address')"
          :info="
            $t(
              !isB2C
                ? 'This e-mail address is used to send the order confirmation, invoice and to log in to the portal where the tickets can be downloaded'
                : 'This email address will be used for the order confirmation and the instructions to download your tickets'
            )
          " />
      </div>
      <Input name="contactDetails.phonenumber" aria-label="Phone Number" class="col-span-2" :label="$t('Phone')" />
    </div>
  </CheckoutCard>
</template>
<script setup lang="ts">
import { isoCountry2 } from "@xs2event/js-lib";
import { Input, Select } from "@xs2event/js-lib/components";
import { isB2C, brandconfig } from "@/brandconfig";
import CheckoutCard from "./CheckoutCard.vue";

const countryOptions = isoCountry2.map((country) => ({
  label: country.nativeName == country.name ? country.name : `${country.name} / ${country.nativeName}`,
  value: country.code3,
}));
</script>
